import { Component, DoCheck, OnInit } from "@angular/core";
import { Router, RouterLink, RouterLinkActive } from "@angular/router";
import { LogOutService } from "../services/log-out.service";
import { MatList, MatListItem } from "@angular/material/list";


@Component({
    selector: "app-nav",
    templateUrl: "./nav.component.html",
    styleUrls: ["./nav.component.scss"],
    imports: [MatList, MatListItem, RouterLink, RouterLinkActive]
})
export class NavComponent implements OnInit, DoCheck {
  highlightConfigNavItem: boolean = false;

  constructor(private router: Router, public logOutService: LogOutService) {}

  ngOnInit() {}

  ngDoCheck() {
    //Logic to disbale plant / shift dropdown for Update config screen
    this.router.events.subscribe((val: any) => {
      if (val.url == "/updateConfiguration" || val.url == "/configuration") {
        this.highlightConfigNavItem = true;
      } else {
        this.highlightConfigNavItem = false;
      }
    });
  }
}
